import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'

export default function ModalLogout({ isLogoutModalOpen, setIsLogoutModalOpen, handleLogout }) {
  return (
    <AnimatePresence>
        {isLogoutModalOpen && (
    <motion.div onClick={() => setIsLogoutModalOpen(false)} className="fixed inset-0 bg-black/50 bg-opacity-50  flex items-center justify-center z-20"
    initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
    >
          <div className="bg-background p-6 rounded-lg w-96">
            <h3 className="text-xl text-text font-semibold">
              ¿Estás seguro de que quieres cerrar sesión?
            </h3>
            <div className="mt-4 flex justify-end space-x-4">
              <button
                className="text-gray-600 hover:text-indigo-600"
                onClick={() => setIsLogoutModalOpen(false)}
              >
                Cancelar
              </button>
              <button onClick={handleLogout} className="text-red-600 hover:text-red-800">
                Confirmar
              </button>
            </div>
          </div>
        </motion.div>
        )}
        </AnimatePresence>
  )
}
